<template>
<div class="md-layout text-center">
    <vue-headful title="Área de acesso" />
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
        <form @submit.prevent="login">
            <login-card header-color="site">

                <h3 slot="title" class="title">AREA DE ACESSO</h3>

                <md-button slot="buttons" href="#" class="md-simple md-white logoButton">
                    <img :src="logo" alt="">
                </md-button>

                <div class="md-form-group" slot="inputs">
                    <div v-if="message" class="alert alert-danger">
                        <strong>{{ message }}</strong>
                    </div>
                </div>

                <div class="md-form-group" slot="inputs">
                    <md-field :class="{ 'md-error': errors.usuario }">
                        <md-icon>face</md-icon>
                        <label>USUÁRIO</label>
                        <md-input v-model="usuario.usuario" placeholder="Digite o Usuário, Matrícula ou CPF"></md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.usuario">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.usuario" class="validErro"> {{ errors.usuario[0] }}</div>
                </div>

                <div class="md-form-group" slot="inputs">
                    <md-field :class="{ 'md-error': errors.password }">
                        <md-icon>lock_outline</md-icon>
                        <label>SENHA</label>
                        <md-input v-model="usuario.password" type="password" inputmode="numeric" placeholder="Digite sua Senha"></md-input>
                    </md-field>
                    <div v-if="errors.password" class="validErro"> {{ errors.password[0] }}</div>
                </div>
                <md-button type="submit" slot="footer" class="md-site md-block md-lg">
                    ENTRAR
                </md-button>
            </login-card>
        </form>
    </div>
</div>
</template>

<script>
import {
    LoginCard
} from "@/components";
import {
    usuarioKey
} from '@/global'
import Notify from '@/config/mixins/notify'
import axios from 'axios'
import preLoader from '@/config/mixins/preLoader';

export default {
    components: {
        LoginCard
    },

    data() {
        return {
            usuario: {},
            permissao: {},
            logo: "./img/logo2.png",
            message: null,
            errors: {},
        };
    },

    mixins: [Notify, preLoader],

    methods: {
        login() {
            //this.usuario.timeToken = 2
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'login', this.usuario)
                .then(response => {               
                    if (response.data.status) {
                        let dataUsuario = response.data.usuario
                        let perm = response.data.listaPermissoes
                        for (let i in perm) {
                            this.permissao[perm[i]] = true
                        }
                        dataUsuario.permissao = this.permissao
                        this.$store.commit('setUsuario', dataUsuario);
                        this.$store.commit('setPermissoes', dataUsuario.permissoes);
                        axios.defaults.headers.common['authorization'] = 'Bearer ' + this.$store.state.usuario.token
                        this.errors = ''
                        this.message = null
                        this.redirectPage(response.data.senhaSistema, dataUsuario.id)
                    } else if (response.data.errors) {
                        this.errors = response.data.errors;
                        this.message = null
                    } else {
                        this.errors = ''
                        this.message = response.data.message;
                    }
                })
                .catch(e => {
                    if (e == 'Error: Network Error') {
                        this.message = 'Servidor fora do ar, tente mais tarde.'
                    } else {
                        this.message = e
                    }
                })
                .finally(function () {
                    loader.hide();
                });
        },

        redirectPage(senha, id) {
            if (this.usuario.password == '123456') {
                this.$store.commit('setUpdatePassword', false)
                this.$router.push({
                    name: 'usuarioUpdatePerfil',
                    params: { id: id }
                })
            } else {
                this.$store.commit('setUpdatePassword', true)
                this.$router.push({
                    name: 'Dashboard'
                })
            }

        }
    },
}
</script>

<style>
.logoButton {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
}

.validErro {
    margin-top: -10px !important;
    color: red;
    font-weight: 400;
}
</style>
